import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useViewContext } from "@/contexts/ViewContext";

interface WorkspaceChipProps {
  active: "properties" | "jobs";
  className?: string;
  compact?: boolean;
}

export function WorkspaceChip({ active, className, compact }: WorkspaceChipProps) {
  const navigate = useNavigate();
  const { setViewContext } = useViewContext();

  const goProperties = () => {
    setViewContext("owner");
    navigate("/owner/properties");
  };
  const goJobs = () => {
    setViewContext("cleaner");
    navigate("/worker/schedule");
  };

  return (
    <div
      className={cn(
        "flex gap-1.5 rounded-[13px] border-[1.5px] border-[#e6edf1] bg-white p-1",
        compact ? "w-fit" : "w-full sm:w-fit",
        className,
      )}
    >
      <button
        type="button"
        onClick={goProperties}
        className={cn(
          "flex min-h-10 flex-1 items-center justify-center rounded-[10px] px-4 text-[14px] font-bold sm:flex-none",
          active === "properties" ? "bg-[#e2eeed] text-[#15776d]" : "bg-transparent text-[#64748b]",
        )}
      >
        Properties
      </button>
      <button
        type="button"
        onClick={goJobs}
        className={cn(
          "flex min-h-10 flex-1 items-center justify-center rounded-[10px] px-4 text-[14px] font-bold sm:flex-none",
          active === "jobs" ? "bg-[#e2eeed] text-[#15776d]" : "bg-transparent text-[#64748b]",
        )}
      >
        Jobs
      </button>
    </div>
  );
}
